import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SDatePicker from '@ui/components/common/SDatePicker';
import { FileUpload } from '@ui/components/common';
import { Controller, useFormContext } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Grid from '@mui/material/Grid2';
import { systemApi } from '@application/api/endpoints/system-api';
import { toast } from 'react-toastify';
const ManualEntryForm = ({ setSelectedFile, id }) => {
    const { t } = useTranslation();
    const [assetSystems, setAssetSystems] = useState([]);
    const { control, formState: { errors } } = useFormContext();
    const handleFileUpload = (file) => {
        if (file) {
            setSelectedFile([file]);
        }
    };
    const FetchAssetSystems = async (id) => {
        try {
            var response = await systemApi.getAssetSystems(id);
            if (response.isSuccess) {
                setAssetSystems(response.data);
            }
        }
        catch (error) {
            toast.error(t('SomethingWentWrong'));
        }
        finally {
        }
    };
    useEffect(() => {
        if (id) {
            FetchAssetSystems(id);
        }
    }, [id]);
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: 12, children: _jsx(Controller, { name: 'licensePlate', control: control, rules: {
                        // required: {
                        //   value: true,
                        //   message: 'License# is required.'
                        // },
                        maxLength: {
                            value: 500,
                            message: 'License# cannot exceed 500 characters.'
                        }
                        // validate: (value) => {
                        //   if (value && !value.trim()) {
                        //     return 'License# is required.';
                        //   }
                        //   return true;
                        // }
                    }, render: ({ field }) => (_jsx(TextField, { ...field, label: t('License#'), multiline: true, rows: 1, fullWidth: true, error: !!errors.licensePlate, helperText: errors.licensePlate?.message, inputProps: {
                            maxLength: 500
                        } })) }) }), _jsx(Grid, { size: 6, children: _jsx(Controller, { name: 'incidentDate', control: control, render: ({ field }) => (_jsx(SDatePicker, { ...field, label: 'Incident Date', value: field.value, onChange: (val) => field.onChange(val), placeholder: 'DateTime', errormsg: errors.incidentDate ? 'Incident date is required' : '' })) }) }), _jsx(Grid, { size: 6, children: _jsx(Controller, { name: 'incidentTime', control: control, render: ({ field }) => (_jsx(Box, { width: '100%', children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(TimePicker, { sx: { width: '100%' }, label: t('Incident Time'), value: field.value, onChange: (newValue) => {
                                    field.onChange(newValue);
                                }, format: 'HH:mm', ampm: false, slotProps: {
                                    textField: {
                                        size: 'medium',
                                        sx: {
                                            width: '100%',
                                            border: 'none'
                                        }
                                    }
                                } }) }) })) }) }), _jsx(Grid, { size: 12, children: _jsx(Controller, { name: 'description', control: control, rules: {
                        required: {
                            value: true,
                            message: 'Description is required.'
                        },
                        maxLength: {
                            value: 500,
                            message: 'Description cannot exceed 500 characters.'
                        },
                        validate: (value) => {
                            if (value && !value.trim()) {
                                return 'Description is required.';
                            }
                            return true;
                        }
                    }, render: ({ field }) => (_jsx(TextField, { ...field, label: t('Description'), multiline: true, rows: 4, fullWidth: true, error: !!errors.description, helperText: errors.description?.message })) }) }), _jsx(Grid, { size: 12, children: _jsx(Controller, { name: 'score', control: control, rules: {
                        max: {
                            value: 100,
                            message: 'Score must be less than or equal to 100'
                        },
                        min: {
                            value: 0,
                            message: 'Score must be greater than or equal to 0'
                        }
                    }, render: ({ field }) => (_jsx(TextField, { ...field, type: 'number', label: t('SeverityScore'), fullWidth: true, error: !!errors.score, helperText: errors.score?.message })) }) }), _jsx(Grid, { size: 12, children: _jsx(Controller, { name: 'systemId', control: control, 
                    // rules={{ required: t('RequiredField')! }}
                    render: ({ field }) => (_jsx(TextField, { ...field, select: true, label: t('SystemName'), fullWidth: true, error: !!errors.systemId, helperText: errors.systemId?.message, onChange: (e) => {
                            const selectedSystem = assetSystems?.find((system) => system.systemName === e.target.value);
                            if (selectedSystem) {
                                field.onChange(selectedSystem.systemId);
                            }
                        }, value: assetSystems?.find((system) => system.systemId === field.value)?.systemName || '', children: assetSystems?.length > 0 ? (assetSystems?.map((system) => (_jsx(MenuItem, { value: system.systemName, children: system.systemName }, system.systemId)))) : (_jsx(MenuItem, { value: '', disabled: true, children: t('NoSystemsAvailable') })) })) }) }), _jsxs(Grid, { size: 12, children: [_jsx(Controller, { name: 'location', control: control, rules: {
                            maxLength: {
                                value: 500,
                                message: 'Location cannot exceed 500 characters.'
                            }
                        }, render: ({ field }) => (_jsx(TextField, { ...field, label: t('Location'), multiline: true, rows: 2, fullWidth: true, error: !!errors.location, helperText: errors.location?.message })) }), ' '] }), _jsx(Grid, { size: 12, children: _jsx(FileUpload, { onChange: handleFileUpload, allowedFileTypes: ['PNG', 'JPG', 'JPEG', 'GIF'], allowedFileTypesText: 'PNG, JPG, JPEG, GIF', allowedFileSize: 5, uploadLabel: 'Upload File', multiple: false, setVehicleDetails: () => { } }) })] }));
};
export default ManualEntryForm;
